var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 59C46.0163 59 59 46.0163 59 30C59 13.9837 46.0163 1 30 1C13.9837 1 1 13.9837 1 30C1 46.0163 13.9837 59 30 59Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 18.7285H14C13.4477 18.7285 13 19.1762 13 19.7285V40.2735C13 40.8258 13.4477 41.2735 14 41.2735H46C46.5523 41.2735 47 40.8258 47 40.2735V19.7285C47 19.1762 46.5523 18.7285 46 18.7285Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5029 46.666C43.501 46.666 43.5 46.6641 43.499 46.6641V45.1152V44.1152H42.499H26.001L25.998 37.8848L42.499 37.8828H43.499V36.8828V35.3379C43.5 35.3379 43.501 35.3359 43.5029 35.3359L52.1729 40.998V41L43.5029 46.666Z",
    fill: "#FFB03D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.499 44.8203L50.3447 41L44.499 37.1816V38.8828H26.998V43.1152H44.499V44.8203ZM43.5059 47.668C42.9844 47.668 42.499 47.252 42.499 46.6641V45.1152H26.001C25.4482 45.1152 24.998 44.6699 24.998 44.1172V37.8848C24.998 37.332 25.4482 36.8828 26.001 36.8828H42.499V35.3379C42.499 34.75 42.9844 34.334 43.5059 34.334C43.6885 34.334 43.876 34.3848 44.0488 34.498L52.7207 40.1621C53.3232 40.5566 53.3232 41.4414 52.7207 41.8359L44.0488 47.5039C43.876 47.6172 43.6885 47.668 43.5059 47.668Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19.5L30.5 29.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 19.5L30.5 29.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMail);
export default __webpack_public_path__ + "static/media/send-mail.cddc908130e2ae38e07a58149cb43ae7.svg";
export { ForwardRef as ReactComponent };